<template>
  <div id="app">
    <!-- 路由切走时保留聊天页实例，避免 SSE 回调绑定的组件被销毁 -->
    <keep-alive include="AppMain">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: 'App',
}
</script>
<style></style>
